module.exports = __webpack_public_path__ + "static/media/covid.dd69e30c.jpg";